"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockMenu = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const ui_1 = require("@jsonjoy.com/ui");
const FontStyleButton_1 = require("@jsonjoy.com/ui/lib/2-inline-block/FontStyleButton");
const slate_1 = require("slate");
const slate_react_1 = require("slate-react");
const keys_1 = require("../util/keys");
const settings_1 = require("./callout/settings");
const Sidetip_1 = require("@jsonjoy.com/ui/lib/1-inline/Sidetip");
const indentation_1 = require("../behavior/indentation");
const behavior_1 = require("../behavior");
const lists_1 = require("../behavior/lists");
const font_1 = require("../behavior/font");
const pilcrow_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/pilcrow"));
const quote_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/quote"));
const code_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/code"));
const wrap_text_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/wrap-text"));
const message_2_exclamation_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/message-2-exclamation"));
const columns_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/columns"));
const heading_1_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/heading-1"));
const heading_2_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/heading-2"));
const heading_3_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/heading-3"));
const heading_4_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/heading-4"));
const heading_5_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/heading-5"));
const heading_6_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/heading-6"));
const type_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/type"));
const list_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/list"));
const list_ordered_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/list-ordered"));
const list_todo_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/list-todo"));
const stairs_up_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/stairs-up"));
const align_left_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/align-left"));
const align_center_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/align-center"));
const align_right_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/align-right"));
const align_justify_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/align-justify"));
const indent_increase_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/indent-increase"));
const indent_decrease_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/indent-decrease"));
const typography_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/typography"));
// Block icons
const ParagraphIcon = (props) => (React.createElement(pilcrow_1.default, { width: 16, height: 16, ...props }));
const BlockquoteIcon = (props) => (React.createElement(quote_1.default, { width: 16, height: 16, ...props }));
const CodeBlockIcon = (props) => (React.createElement(code_1.default, { width: 16, height: 16, ...props }));
const PreIcon = (props) => React.createElement(wrap_text_1.default, { width: 16, height: 16, ...props });
// const CalloutIcon = makeIcon({set: 'lucide', icon: 'message-square-warning', width: 16, height: 16});
// const CalloutIcon = makeIcon({set: 'vscode', icon: 'note', width: 16, height: 16});
const CalloutIcon = (props) => (React.createElement(message_2_exclamation_1.default, { width: 16, height: 16, ...props }));
const ColumnsIcon = (props) => (React.createElement(columns_1.default, { width: 16, height: 16, ...props }));
// Heading icons
// const H1Icon = makeIcon({set: 'tabler', icon: 'h-1', width: 16, height: 16});
// const H2Icon = makeIcon({set: 'tabler', icon: 'h-2', width: 16, height: 16});
// const H3Icon = makeIcon({set: 'tabler', icon: 'h-3', width: 16, height: 16});
// const H4Icon = makeIcon({set: 'tabler', icon: 'h-4', width: 16, height: 16});
// const H5Icon = makeIcon({set: 'tabler', icon: 'h-5', width: 16, height: 16});
// const H6Icon = makeIcon({set: 'tabler', icon: 'h-6', width: 16, height: 16});
const H1Icon = (props) => React.createElement(heading_1_1.default, { width: 16, height: 16, ...props });
const H2Icon = (props) => React.createElement(heading_2_1.default, { width: 16, height: 16, ...props });
const H3Icon = (props) => React.createElement(heading_3_1.default, { width: 16, height: 16, ...props });
const H4Icon = (props) => React.createElement(heading_4_1.default, { width: 16, height: 16, ...props });
const H5Icon = (props) => React.createElement(heading_5_1.default, { width: 16, height: 16, ...props });
const H6Icon = (props) => React.createElement(heading_6_1.default, { width: 16, height: 16, ...props });
const TitleIcon = (props) => (React.createElement(type_1.default, { width: 16, height: 16, ...props }));
// List icons
// const ULIcon = makeIcon({set: 'ibm_32', icon: 'list--bulleted', width: 16, height: 16});
const ULIcon = (props) => React.createElement(list_1.default, { width: 16, height: 16, ...props });
// const OLIcon = makeIcon({set: 'ibm_32', icon: 'list--numbered', width: 16, height: 16});
const OLIcon = (props) => React.createElement(list_ordered_1.default, { width: 16, height: 16, ...props });
// const ChecklistIcon = makeIcon({set: 'ibm_32', icon: 'list--checked', width: 16, height: 16});
// const ChecklistIcon = makeIcon({set: 'vscode', icon: 'checklist', width: 16, height: 16});
const ChecklistIcon = (props) => (React.createElement(list_todo_1.default, { width: 16, height: 16, ...props }));
const StepperIcon = (props) => (React.createElement(stairs_up_1.default, { width: 16, height: 16, ...props }));
// Layout icons
const AlignLeftIcon = (props) => (React.createElement(align_left_1.default, { width: 16, height: 16, ...props }));
const AlignCenterIcon = (props) => (React.createElement(align_center_1.default, { width: 16, height: 16, ...props }));
const AlignRightIcon = (props) => (React.createElement(align_right_1.default, { width: 16, height: 16, ...props }));
const AlignJustifyIcon = (props) => (React.createElement(align_justify_1.default, { width: 16, height: 16, ...props }));
const IndentIcon = (props) => (React.createElement(indent_increase_1.default, { width: 16, height: 16, ...props }));
const DedentIcon = (props) => (React.createElement(indent_decrease_1.default, { width: 16, height: 16, ...props }));
const TypographyIcon = (props) => (React.createElement(typography_1.default, { width: 16, height: 16, ...props }));
class BlockMenu {
    constructor(mutxt) {
        this.mutxt = mutxt;
        this.exec = (fn) => (event) => {
            event.preventDefault();
            fn();
            slate_react_1.ReactEditor.focus(this.mutxt.editor);
            this.mutxt.setFocused(true);
            this.mutxt.sync(false);
        };
    }
    start() {
        return () => { };
    }
    build() {
        const format = this.currentBlockFormat();
        const head = this.headFor(format);
        return {
            name: 'Block options',
            expand: 0,
            minWidth: 300,
            children: [
                {
                    name: head?.name ?? 'Block',
                    icon: head?.icon,
                    minWidth: 269,
                    expand: 0,
                    children: [this.menuBlocks(), this.menuHeadings(), this.menuLists(), this.menuLayout(), this.menuStyling()],
                },
            ],
        };
    }
    buildToolbarMenu(size) {
        const blockMenu = {
            name: 'Block menu',
            maxToolbarItems: 4,
            minWidth: 288,
            children: [this.menuBlocks(), this.menuHeadings(), this.menuLists(), this.menuLayout(), this.menuStyling()],
        };
        if (size < 1) {
            blockMenu.maxToolbarItems = 1;
        }
        else if (size < 2) {
            blockMenu.maxToolbarItems = 3;
        }
        return blockMenu;
    }
    // ----------------------------------------------------------------- Sections
    menuBlocks() {
        return {
            id: 'block-blocks',
            name: 'Blocks',
            expand: 3,
            children: [
                this.itemParagraph(),
                this.itemBlockquote(),
                this.itemCodeBlock(),
                this.itemPre(),
                this.itemCallout(),
                this.itemColumns(),
            ],
        };
    }
    menuHeadings() {
        return {
            id: 'block-headings',
            name: 'Headings',
            sepBefore: true,
            expand: 3,
            children: [
                this.itemH1(),
                this.itemH2(),
                this.itemH3(),
                this.itemH4(),
                this.itemH5(),
                this.itemH6(),
                { name: 'sep-title', sep: true },
                this.itemTitle(),
                this.itemSubtitle(),
            ],
        };
    }
    menuLists() {
        return {
            id: 'block-lists',
            name: 'Lists',
            expand: 8,
            sepBefore: true,
            children: [this.itemUL(), this.itemOL(), this.itemChecklist(), this.itemStepper()],
        };
    }
    menuLayout() {
        return {
            id: 'block-layout',
            name: 'Layout',
            expand: 3,
            sepBefore: true,
            children: [
                this.itemAlignLeft(),
                this.itemAlignCenter(),
                this.itemAlignRight(),
                this.itemAlignJustify(),
                { name: 'sep-indent', sep: true },
                this.itemIndent(),
                this.itemDedent(),
            ],
        };
    }
    menuStyling() {
        return {
            id: 'block-styling',
            name: 'Styling',
            // icon: () => <TypographyIcon />,
            expand: 4,
            sepBefore: true,
            children: [this.menuTypesetting()],
        };
    }
    menuTypesetting() {
        return {
            id: 'block-typesetting',
            name: 'Typesetting',
            text: 'font face family typography typeface',
            icon: () => React.createElement(TypographyIcon, null),
            expand: 4,
            openOnTitleHov: true,
            children: [
                this.itemBlockFont('sans', 'Sans-serif', 'sans gothic grotesque modern'),
                this.itemBlockFont('serif', 'Serif', 'serif traditional roman'),
                this.itemBlockFont('slab', 'Slab', 'slab egyptian thick serif'),
                this.itemBlockFont('mono', 'Monospace', 'mono fixed code typewriter courier'),
            ],
        };
    }
    itemBlockFont(kind, name, text) {
        const mutxt = this.mutxt;
        const onSelect = this.exec(() => (0, font_1.setBlockFont)(mutxt.editor, kind));
        const Option = ({ size }) => {
            mutxt.version.use();
            const active = (0, font_1.isBlockFontActive)(mutxt.editor, kind);
            return React.createElement(FontStyleButton_1.FontStyleButton, { kind: kind, size: size, active: active, onMouseDown: onSelect });
        };
        return {
            name,
            text,
            icon: () => React.createElement(Option, { size: 16 }),
            iconBig: () => React.createElement(Option, null),
            active: ui_1.rsync.comp([mutxt.version], () => (0, font_1.isBlockFontActive)(mutxt.editor, kind)),
            onSelect,
        };
    }
    // -------------------------------------------------------------- Block items
    itemParagraph() {
        return this.blockItem('p', {
            name: 'Paragraph',
            text: 'p body text plain',
            icon: () => React.createElement(ParagraphIcon, null),
            keys: ['Primary', 'Alt', '0'],
        });
    }
    itemBlockquote() {
        return this.blockItem('blockquote', {
            name: 'Blockquote',
            text: 'quote citation cite epigraph',
            icon: () => React.createElement(BlockquoteIcon, null),
            keys: ['Primary', 'Alt', '9'],
        });
    }
    itemCodeBlock() {
        return this.blockItem('code-block', {
            name: 'Code block',
            text: 'snippet program syntax monospace fenced',
            icon: () => React.createElement(CodeBlockIcon, null),
            keys: ['Primary', 'Shift', 'c'],
        });
    }
    itemPre() {
        return this.blockItem('pre', {
            name: 'Pre-formatted',
            text: 'preformatted monospace verbatim ascii',
            icon: () => React.createElement(PreIcon, null),
        });
    }
    itemCallout() {
        const mutxt = this.mutxt;
        const base = this.blockItem('callout', {
            name: 'Callout',
            text: 'admonition alert info note warning tip box',
            icon: () => React.createElement(CalloutIcon, null),
        });
        return {
            ...base,
            onSelect: this.exec(() => {
                const wasActive = this.currentBlockFormat() === 'callout';
                (0, behavior_1.toggleBlock)(mutxt.editor, 'callout');
                if (wasActive)
                    return;
                const seed = {
                    variant: settings_1.DEFAULT_VARIANT,
                };
                slate_1.Transforms.setNodes(mutxt.editor, seed, {
                    match: (n) => slate_1.Element.isElement(n) && slate_1.Editor.isBlock(mutxt.editor, n) && n.type === 'callout',
                });
            }),
        };
    }
    itemColumns() {
        return this.blockItem('columns', {
            name: 'Two columns',
            text: 'split layout multi-column side-by-side grid',
            icon: () => React.createElement(ColumnsIcon, null),
        });
    }
    // ------------------------------------------------------------ Heading items
    itemH1() {
        return this.blockItem('h1', {
            name: 'Heading 1',
            text: 'h1 title section header',
            icon: () => React.createElement(H1Icon, null),
            keys: ['Primary', 'Alt', '1'],
        });
    }
    itemH2() {
        return this.blockItem('h2', {
            name: 'Heading 2',
            text: 'h2 subheading section header',
            icon: () => React.createElement(H2Icon, null),
            keys: ['Primary', 'Alt', '2'],
        });
    }
    itemH3() {
        return this.blockItem('h3', {
            name: 'Heading 3',
            text: 'h3 subheading section header',
            icon: () => React.createElement(H3Icon, null),
            keys: ['Primary', 'Alt', '3'],
        });
    }
    itemH4() {
        return this.blockItem('h4', {
            name: 'Heading 4',
            text: 'h4 subheading section header',
            icon: () => React.createElement(H4Icon, null),
            keys: ['Primary', 'Alt', '4'],
        });
    }
    itemH5() {
        return this.blockItem('h5', {
            name: 'Heading 5',
            text: 'h5 subheading section header',
            icon: () => React.createElement(H5Icon, null),
            keys: ['Primary', 'Alt', '5'],
        });
    }
    itemH6() {
        return this.blockItem('h6', {
            name: 'Heading 6',
            text: 'h6 subheading section header',
            icon: () => React.createElement(H6Icon, null),
            keys: ['Primary', 'Alt', '6'],
        });
    }
    itemTitle() {
        return this.blockItem('title', {
            name: 'Title',
            text: 'document title page name',
            display: () => React.createElement("span", { style: { fontWeight: 'bold' } }, 'Title'),
            icon: () => React.createElement(TitleIcon, null),
        });
    }
    itemSubtitle() {
        return this.blockItem('subtitle', {
            name: 'Subtitle',
            text: 'subhead deck tagline',
            display: () => React.createElement("span", { style: { opacity: 0.7 } }, 'Subtitle'),
            icon: () => React.createElement(TitleIcon, null),
        });
    }
    // --------------------------------------------------------------- List items
    itemUL() {
        const mutxt = this.mutxt;
        const applyUlType = (ulType) => {
            if ((0, lists_1.getActiveUlType)(mutxt.editor) === null)
                (0, behavior_1.toggleBlock)(mutxt.editor, 'ul');
            (0, lists_1.setUlType)(mutxt.editor, ulType);
        };
        return this.blockItem('ul', {
            name: 'Bulleted list',
            text: 'ul unordered bullet dot point',
            icon: () => React.createElement(ULIcon, null),
            keys: ['Primary', 'Alt', '8'],
            children: [
                {
                    name: 'Disc bullets',
                    text: 'ul disc filled solid round',
                    icon: () => (React.createElement("div", { style: { width: 16, height: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                        React.createElement("div", { style: { width: 8, height: 8, borderRadius: '50%', backgroundColor: 'currentColor' } }))),
                    active: ui_1.rsync.comp([mutxt.version], () => (0, lists_1.isUlTypeActive)(mutxt.editor, 'disc')),
                    onSelect: this.exec(() => applyUlType('disc')),
                },
                {
                    name: 'Circle bullets',
                    text: 'ul circle ring outline hollow',
                    icon: () => (React.createElement("div", { style: { width: 16, height: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                        React.createElement("div", { style: { width: 6, height: 6, borderRadius: '50%', border: '1px solid currentColor' } }))),
                    active: ui_1.rsync.comp([mutxt.version], () => (0, lists_1.isUlTypeActive)(mutxt.editor, 'circle')),
                    onSelect: this.exec(() => applyUlType('circle')),
                },
                {
                    name: 'Square bullets',
                    text: 'ul square box block',
                    icon: () => (React.createElement("div", { style: { width: 16, height: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                        React.createElement("div", { style: { width: 6, height: 6, backgroundColor: 'currentColor' } }))),
                    active: ui_1.rsync.comp([mutxt.version], () => (0, lists_1.isUlTypeActive)(mutxt.editor, 'square')),
                    onSelect: this.exec(() => applyUlType('square')),
                },
            ],
        });
    }
    itemOL() {
        const mutxt = this.mutxt;
        const applyOlType = (olType) => {
            if ((0, lists_1.getActiveOlType)(mutxt.editor) === null)
                (0, behavior_1.toggleBlock)(mutxt.editor, 'ol');
            (0, lists_1.setOlType)(mutxt.editor, olType);
        };
        const olItem = (name, olType, example, text) => ({
            name,
            text: [text, example].filter(Boolean).join(' ') || undefined,
            right: example ? () => React.createElement(Sidetip_1.Sidetip, { small: true }, example) : undefined,
            active: ui_1.rsync.comp([mutxt.version], () => (0, lists_1.isOlTypeActive)(mutxt.editor, olType)),
            onSelect: this.exec(() => applyOlType(olType)),
        });
        return this.blockItem('ol', {
            name: 'Numbered list',
            text: 'ol ordered enumerated number',
            icon: () => React.createElement(OLIcon, null),
            keys: ['Primary', 'Alt', '7'],
            children: [
                olItem('Decimal', 'decimal', '1, 2, 3', 'arabic numeral'),
                olItem('Decimal w/ zero', 'decimal-leading-zero', '01, 02, 03', 'padded zero leading'),
                olItem('Lower Roman', 'lower-roman', 'i, ii, iii', 'roman numeral lowercase'),
                olItem('Upper Roman', 'upper-roman', 'I, II, III', 'roman numeral uppercase'),
                olItem('Lower alpha', 'lower-alpha', 'a, b, c', 'alphabetic letter lowercase'),
                olItem('Upper alpha', 'upper-alpha', 'A, B, C', 'alphabetic letter uppercase'),
                olItem('Lower Greek', 'lower-greek', 'α, β, γ', 'greek alphabet alpha beta gamma'),
                {
                    name: 'More styles',
                    text: 'extra additional language',
                    sepBefore: true,
                    more: true,
                    children: [
                        olItem('Hiragana', 'hiragana', 'あ, い, う', 'japanese kana'),
                        olItem('Katakana', 'katakana', 'ア, イ, ウ', 'japanese kana'),
                        olItem('CJK ideographic', 'cjk-ideographic', '一, 二, 三', 'chinese kanji hanzi'),
                        olItem('Hebrew', 'hebrew', undefined, 'aleph hebrew alphabet'),
                        olItem('Armenian', 'armenian', undefined, 'armenian alphabet'),
                    ],
                },
            ],
        });
    }
    itemChecklist() {
        return this.blockItem('checklist', {
            name: 'Checklist',
            text: 'todo task checkbox check tick to-do',
            icon: () => React.createElement(ChecklistIcon, null),
        });
    }
    itemStepper() {
        return this.blockItem('stepper', {
            name: 'Stepper',
            text: 'stepper steps progress wizard timeline milestones flow',
            icon: () => React.createElement(StepperIcon, null),
        });
    }
    // ------------------------------------------------------------------- Layout
    itemAlignLeft() {
        return this.layoutItem('left', {
            name: 'Align left',
            text: 'left start alignment',
            keys: ['Primary', 'Shift', 'l'],
            icon: () => React.createElement(AlignLeftIcon, null),
        });
    }
    itemAlignCenter() {
        return this.layoutItem('center', {
            name: 'Align center',
            text: 'middle centered alignment',
            keys: ['Primary', 'Shift', 'e'],
            icon: () => React.createElement(AlignCenterIcon, null),
        });
    }
    itemAlignRight() {
        return this.layoutItem('right', {
            name: 'Align right',
            text: 'right end alignment',
            keys: ['Primary', 'Shift', 'r'],
            icon: () => React.createElement(AlignRightIcon, null),
        });
    }
    itemAlignJustify() {
        return this.layoutItem('justify', {
            name: 'Justify',
            text: 'justified fill stretch align both',
            keys: ['Primary', 'Shift', 'j'],
            icon: () => React.createElement(AlignJustifyIcon, null),
        });
    }
    // -------------------------------------------------------------- Indentation
    itemIndent() {
        const mutxt = this.mutxt;
        const keys = ['Primary', ']'];
        const formattedKeys = (0, keys_1.formatKeys)(keys);
        return {
            name: 'Increase indent',
            text: 'tab right shift in nest',
            icon: () => React.createElement(IndentIcon, null),
            right: () => React.createElement(Sidetip_1.Sidetip, { small: true }, formattedKeys),
            keys: [formattedKeys],
            disabled: ui_1.rsync.comp([mutxt.version], () => (0, indentation_1.getActiveIndent)(mutxt.editor) >= indentation_1.MAX_INDENT),
            onSelect: this.exec(() => (0, indentation_1.indentBlock)(mutxt.editor)),
        };
    }
    itemDedent() {
        const mutxt = this.mutxt;
        const keys = ['Primary', '['];
        const formattedKeys = (0, keys_1.formatKeys)(keys);
        return {
            name: 'Decrease indent',
            text: 'outdent unindent shift left untab',
            icon: () => React.createElement(DedentIcon, null),
            right: () => React.createElement(Sidetip_1.Sidetip, { small: true }, formattedKeys),
            keys: [formattedKeys],
            disabled: ui_1.rsync.comp([mutxt.version], () => (0, indentation_1.getActiveIndent)(mutxt.editor) <= 0),
            onSelect: this.exec(() => (0, indentation_1.dedentBlock)(mutxt.editor)),
        };
    }
    // ------------------------------------------------------------------ Helpers
    blockItem(format, config) {
        const mutxt = this.mutxt;
        const keys = config.keys;
        const formattedKeys = keys ? (0, keys_1.formatKeys)(keys) : undefined;
        return {
            ...config,
            keys: formattedKeys ? [formattedKeys] : undefined,
            right: keys ? () => React.createElement(Sidetip_1.Sidetip, { small: true }, formattedKeys) : undefined,
            active: ui_1.rsync.comp([mutxt.version], () => this.currentBlockFormat() === format),
            onSelect: this.exec(() => (0, behavior_1.toggleBlock)(mutxt.editor, format)),
        };
    }
    layoutItem(alignment, config) {
        const mutxt = this.mutxt;
        const keys = config.keys;
        const formattedKeys = keys ? (0, keys_1.formatKeys)(keys) : undefined;
        return {
            ...config,
            keys: formattedKeys ? [formattedKeys] : undefined,
            right: keys ? () => React.createElement(Sidetip_1.Sidetip, { small: true }, formattedKeys) : undefined,
            active: ui_1.rsync.comp([mutxt.version], () => (0, behavior_1.isAlignmentActive)(mutxt.editor, alignment)),
            onSelect: this.exec(() => (0, behavior_1.setAlignment)(mutxt.editor, alignment)),
        };
    }
    currentBlockFormat() {
        return this.mutxt.block.currentBlockFormat();
    }
    headFor(format) {
        switch (format) {
            case 'p':
                return this.itemParagraph();
            case 'h1':
                return this.itemH1();
            case 'h2':
                return this.itemH2();
            case 'h3':
                return this.itemH3();
            case 'h4':
                return this.itemH4();
            case 'h5':
                return this.itemH5();
            case 'h6':
                return this.itemH6();
            case 'title':
                return this.itemTitle();
            case 'subtitle':
                return this.itemSubtitle();
            case 'blockquote':
                return this.itemBlockquote();
            case 'callout':
                return this.itemCallout();
            case 'code-block':
                return this.itemCodeBlock();
            case 'pre':
                return this.itemPre();
            case 'ul':
                return this.itemUL();
            case 'ol':
                return this.itemOL();
            case 'checklist':
                return this.itemChecklist();
            case 'stepper':
                return this.itemStepper();
            case 'columns':
                return this.itemColumns();
            default:
                return null;
        }
    }
}
exports.BlockMenu = BlockMenu;
